import React from 'react';

import { StepLayoutFeatureArea } from '@paragon/contract-library';
import { DistanceField } from '@paragon/material';

interface Props {
  value: Omit<StepLayoutFeatureArea, 'guid'>;
  disabled?: boolean;
  onChange: (value: Omit<StepLayoutFeatureArea, 'guid'>) => void;
}

export function StepFeatureAreaControls({ value, disabled, onChange }: Props) {
  return (
    <DistanceField
      label="Height"
      disabled={disabled}
      value={value.height}
      onSubmit={(height) => {
        onChange({ ...value, height });
      }}
    />
  );
}
